module.exports = __webpack_public_path__ + "static/img/projects-build-a-bear.ebe6c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects-build-a-bear.png
// module id = 8X6c
// module chunks = 1